var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c('div', {
    staticClass: "homecont",
    attrs: {
      "id": "classify"
    }
  }, [_c('div', {
    staticClass: "classify-tab"
  }, [_c('div', {
    staticClass: "tab-first content"
  }, _vm._l(_vm.productTypeList, function (item, index) {
    return _c('span', {
      key: index,
      class: {
        active: _vm.currentIndex === index
      },
      on: {
        "click": function click($event) {
          return _vm.selectMenu(item.id, index);
        }
      }
    }, [_vm._v(_vm._s(item.typeName))]);
  }), 0), _c('div', {
    staticClass: "tab-second content"
  }, [_c('ol', _vm._l(_vm.productTypeList[_vm.currentIndex] && _vm.productTypeList[_vm.currentIndex].children, function (item, index) {
    return _c('li', {
      key: index,
      class: {
        active: _vm.currentSubIndex === index
      },
      on: {
        "click": function click($event) {
          return _vm.selectSubMenu(item.id, index);
        }
      }
    }, [_vm._v(" " + _vm._s(item.typeName) + " ")]);
  }), 0), _vm.arrList.length > 1 ? _c('div', {
    staticClass: "overall",
    on: {
      "click": function click($event) {
        $event.stopPropagation();
        return _vm.handOverall.apply(null, arguments);
      }
    }
  }, [_vm._m(0), _vm._v(" " + _vm._s(this.activeIndex == '全部' ? '全部尺寸' : this.activeIndex) + " "), _vm._m(1)]) : _vm._e(), _vm.sizeStauts ? _c('div', {
    staticClass: "sizeList"
  }, _vm._l(_vm.arrList, function (item, index) {
    return _c('div', {
      key: item
    }, [_c('div', {
      staticClass: "size",
      class: {
        active: _vm.activeIndex == item
      },
      on: {
        "click": function click($event) {
          $event.stopPropagation();
          return _vm.handClick(item);
        }
      }
    }, [_vm._v(" " + _vm._s(item) + " ")])]);
  }), 0) : _vm._e()])]), _c('div', {
    staticClass: "list content"
  }, [_c('ul', [_c('li', {
    staticClass: "list-item"
  }, [_c('div', {
    directives: [{
      name: "infinite-scroll",
      rawName: "v-infinite-scroll",
      value: _vm.onInfinite,
      expression: "onInfinite"
    }, {
      name: "loading",
      rawName: "v-loading",
      value: _vm.loading,
      expression: "loading"
    }],
    staticClass: "hot-wrap",
    attrs: {
      "infinite-scroll-disabled": _vm.disabled
    }
  }, [_vm.recommendList.length === 0 ? _c('div', {
    staticClass: "norecord"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/images/no_record.png")
    }
  }), _c('span', [_vm._v("暂无数据")])]) : _vm._e(), _vm._l(_vm.recommendList, function (list, index) {
    return _c('div', {
      key: index,
      staticClass: "hot-list",
      on: {
        "click": function click($event) {
          $event.stopPropagation();
          return _vm.goDetails(list);
        }
      }
    }, [list.listImagePath ? _c('img', {
      directives: [{
        name: "lazy",
        rawName: "v-lazy",
        value: list.listImagePath.cdnFilePathPc,
        expression: "list.listImagePath.cdnFilePathPc"
      }]
    }) : _vm._e(), _c('div', {
      staticClass: "item-details"
    }, [list.productSku ? _c('em', {
      staticClass: "skuname"
    }, [_vm._v(_vm._s(list.productSku))]) : _c('em', {
      staticClass: "product-name"
    }, [_vm._v(_vm._s(list.productName))]), _c('div', {
      staticClass: "subscript"
    }, [list.discountActivityTag ? _c('div', {
      staticClass: "tip"
    }, [_vm._v(" " + _vm._s(list.discountActivityTag) + " ")]) : _vm._e(), list.giftActivityTag ? _c('div', {
      staticClass: "tip"
    }, [_vm._v(_vm._s(list.giftActivityTag))]) : _vm._e(), list.productLabelType === 1 && list.productLabelType !== 0 ? _c('div', {
      staticClass: "browse"
    }, [_vm._v(" 购买过 ")]) : _vm._e(), list.productLabelType === 2 && list.productLabelType !== 0 ? _c('div', {
      staticClass: "browse"
    }, [_vm._v(" 浏览过 ")]) : _vm._e()]), list.productSku ? _c('p', [_vm._v(_vm._s(list.natureValue))]) : _vm._e(), _c('div', {
      staticClass: "price-region"
    }, [list.realDiscountStatus ? _c('Price', {
      attrs: {
        "price": String(list.realDiscountPrice)
      }
    }) : _c('Price', {
      attrs: {
        "price": list.lowestPrice.split(',')[0]
      }
    }), list.realDiscountStatus ? _c('div', {
      staticStyle: {
        "color": "red",
        "margin-left": "10px",
        "margin-bottom": "2px"
      }
    }, [_vm._v(" 到手价 ")]) : _vm._e()], 1)]), _c('div', {
      staticClass: "chat",
      on: {
        "click": function click($event) {
          $event.stopPropagation();
          return _vm.handChat(list);
        }
      }
    }, [_c('img', {
      attrs: {
        "src": require("@/assets/images/chat.png"),
        "alt": ""
      }
    })])]);
  })], 2)])])]), _c('SKU', {
    ref: "skuRefs"
  })], 1);
};
var staticRenderFns = [function () {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c('div', {
    staticClass: "overall_right"
  }, [_c('img', {
    attrs: {
      "src": require("@/assets/images/size.png"),
      "alt": ""
    }
  })]);
}, function () {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c('div', {
    staticClass: "overall_right"
  }, [_c('img', {
    attrs: {
      "src": require("@/assets/images/arrow-left-copy-copy.png"),
      "alt": ""
    }
  })]);
}];
export { render, staticRenderFns };